import {postMethod, deleteMethod} from '~/api'

async function post(request) {
    return await postMethod('/proxy/ai/assistants', request)
}

async function remove(request) {
    return await deleteMethod('/proxy/ai/assistants', request)
}

export {post, remove}
